import { LitElement } from '@lit'
import '@nova/shopify'

class NovaSelect extends LitElement {
  static properties = {
    formType: { type: String, reflect: true, attribute: 'form-type' },
    formIndex: { type: String, reflect: true, attribute: 'form-index' },
  }

  constructor() {
    super()
    this.formType = ''
    this.formIndex = ''
  }

  firstUpdated() {
    this.initializeSelectOptions()

    if (this.formType === 'add') {
      this.initShopifyCountryProvinceSelector(
        'NewAddressCountry',
        'NewAddressProvince',
        'NewAddressProvinceContainer',
      )
    } else if (this.formType === 'edit') {
      this.initShopifyCountryProvinceSelector(
        `EditAddress_${this.formIndex}Country`,
        `EditAddress_${this.formIndex}Province`,
        `EditAddress_${this.formIndex}ProvinceContainer`,
      )
    }
  }

  initShopifyCountryProvinceSelector(
    countrySelector,
    provinceSelector,
    provinceContainerSelector,
  ) {
    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: provinceContainerSelector,
    })
  }

  initializeSelectOptions = () => {
    const options = this.querySelectorAll('option')
    for (const option of options) {
      const slOption = document.createElement('sl-option')
      slOption.value = option.value.replace(/ /g, '_')
      slOption.textContent = option.textContent
      slOption.dataset.provinces = option.dataset.provinces

      option.replaceWith(slOption)
    }
  }

  createRenderRoot() {
    return this
  }
}

customElements.define('nova-country-select', NovaSelect)
